var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"#101828","fill-rule":"evenodd","d":"m10.94 12-5.941 5.942 1.06 1.06L12 13.062l5.941 5.94 1.061-1.06L13.061 12l5.941-5.941-1.06-1.061L12 10.939 6.06 5l-1.061 1.06z","clip-rule":"evenodd"}})])
}
var staticRenderFns = []

export default { render: render }